/*
 * Site-search command palette - content + behaviour for the Bootstrap modal
 * (#ls-search-modal). Bootstrap itself handles open/close/backdrop/focus-trap/Esc
 * (the navbar button uses data-bs-toggle, so it opens even if this script is slow);
 * this only fills the modal: recent (localStorage) + popular chips when empty, the
 * top live /api/search/ results while typing, keyboard navigation, and the
 * Ctrl-K / Cmd-K / "/" shortcuts.
 *
 * Result text is inserted via textContent / DOM nodes (never innerHTML), so titles
 * and queries can't inject markup.
 */
(function () {
    function init() {
        var modalEl = document.getElementById('ls-search-modal');
        if (!modalEl || !window.bootstrap) return;

        var input = modalEl.querySelector('[data-search-input]');
        var body = modalEl.querySelector('[data-search-body]');
        var footCta = modalEl.querySelector('[data-search-all]');
        var apiUrl = modalEl.getAttribute('data-api') || '/api/search/';
        var resultsUrl = modalEl.getAttribute('data-results-url') || '/search/';
        var modal = bootstrap.Modal.getOrCreateInstance(modalEl);

        var MIN_CHARS = 2;
        var MAX_ITEMS = 6;
        var DEBOUNCE_MS = 220;   // match the other search inputs (live-search.js)
        var RECENT_KEY = 'ls-recent-searches';
        var RECENT_MAX = 5;

        var POPULAR = [];
        try { POPULAR = JSON.parse((document.getElementById('ls-search-popular') || {}).textContent || '[]'); } catch (e) { /* none */ }

        var timer = null;
        var lastQuery = null;
        var results = [];
        var active = -1;

        if (/mac|iphone|ipad/i.test(navigator.platform || navigator.userAgent)) {
            document.querySelectorAll('[data-search-kbd]').forEach(function (el) { el.textContent = '⌘ K'; });
        }

        // --- recent searches (localStorage) ------------------------------
        function readRecent() {
            try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; }
        }
        function recordRecent(term) {
            term = (term || '').trim();
            if (!term) return;
            try {
                var list = readRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
                list.unshift(term);
                localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX)));
            } catch (e) { /* storage may be disabled - non-fatal */ }
        }

        // --- rendering ---------------------------------------------------
        function el(tag, cls, text) {
            var n = document.createElement(tag);
            if (cls) n.className = cls;
            if (text != null) n.textContent = text;
            return n;
        }

        function chip(term, icon) {
            var b = el('button', 'palette-chip');
            b.type = 'button';
            b.appendChild(el('i', icon));
            b.appendChild(document.createTextNode(term));
            b.addEventListener('click', function () { submit(term); });
            return b;
        }

        function section(title) {
            var sec = el('div', 'palette-section');
            sec.appendChild(el('div', 'palette-section-h', title));
            return sec;
        }

        function renderEmpty() {
            body.textContent = '';
            footCta.hidden = true;
            active = -1;
            results = [];

            var recent = readRecent();
            if (recent.length) {
                var rsec = section('Recent');
                var rchips = el('div', 'palette-chips');
                recent.forEach(function (t) { rchips.appendChild(chip(t, 'icon-clock')); });
                rsec.appendChild(rchips);
                body.appendChild(rsec);
            }
            if (POPULAR.length) {
                var psec = section('Popular searches');
                var pchips = el('div', 'palette-chips');
                POPULAR.forEach(function (t) { pchips.appendChild(chip(t, 'icon-trending-up')); });
                psec.appendChild(pchips);
                body.appendChild(psec);
            }
        }

        function appendHighlighted(node, text, query) {
            var q = (query || '').trim();
            var idx = q ? text.toLowerCase().indexOf(q.toLowerCase()) : -1;
            if (idx < 0) { node.appendChild(document.createTextNode(text)); return; }
            node.appendChild(document.createTextNode(text.slice(0, idx)));
            var mark = document.createElement('mark');
            mark.textContent = text.slice(idx, idx + q.length);
            node.appendChild(mark);
            node.appendChild(document.createTextNode(text.slice(idx + q.length)));
        }

        function resultRow(r, i, query) {
            var a = el('a', 'palette-result');
            a.href = r.url;
            a.setAttribute('data-idx', i);

            var ico = el('span', 'palette-result-ico kind-' + (r.kind_css || ''));
            ico.appendChild(el('i', r.kind_icon || 'icon-file-text'));
            a.appendChild(ico);

            var main = el('span', 'palette-result-main');
            var title = el('span', 'palette-result-title');
            appendHighlighted(title, r.title || '', query);
            main.appendChild(title);
            main.appendChild(el('span', 'palette-result-desc', r.product_name || r.kind_display || ''));
            a.appendChild(main);

            a.appendChild(el('span', 'palette-badge kind-text-' + (r.kind_css || ''), r.kind_display || ''));

            a.addEventListener('mouseenter', function () { setActive(i); });
            a.addEventListener('click', function () { recordRecent(query); });
            return a;
        }

        function renderResults(query) {
            body.textContent = '';
            active = -1;

            if (!results.length) {
                var empty = el('div', 'palette-empty');
                empty.appendChild(el('div')).appendChild(el('i', 'icon-search-x'));
                empty.appendChild(document.createTextNode('No matches for “' + query + '”. Try a product name, "silent install", or "license".'));
                body.appendChild(empty);
                footCta.hidden = true;
                return;
            }

            var sec = section('Top results');
            results.forEach(function (r, i) { sec.appendChild(resultRow(r, i, query)); });
            body.appendChild(sec);

            footCta.href = resultsUrl + '?q=' + encodeURIComponent(query);
            footCta.hidden = false;
            setActive(0);
        }

        function setActive(i) {
            active = i;
            body.querySelectorAll('.palette-result').forEach(function (row, idx) {
                row.classList.toggle('active', idx === i);
            });
        }

        function moveActive(delta) {
            if (!results.length) return;
            setActive((active + delta + results.length) % results.length);
            var row = body.querySelectorAll('.palette-result')[active];
            if (row) row.scrollIntoView({ block: 'nearest' });
        }

        // --- search ------------------------------------------------------
        function submit(term) {
            var v = (term != null ? term : input.value).trim();
            if (!v) return;
            recordRecent(v);
            window.location.assign(resultsUrl + '?q=' + encodeURIComponent(v));
        }

        function run() {
            var query = input.value.trim();
            if (query.length < MIN_CHARS) { lastQuery = null; renderEmpty(); return; }
            if (query === lastQuery) return;
            lastQuery = query;
            fetch(apiUrl + '?q=' + encodeURIComponent(query) + '&limit=' + MAX_ITEMS,
                  { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
                .then(function (r) { return r.ok ? r.json() : null; })
                .then(function (data) {
                    if (!data || input.value.trim() !== query) return;  // ignore stale
                    results = (data.results || []).slice(0, MAX_ITEMS);
                    renderResults(query);
                })
                .catch(function () { /* network hiccup: Enter still submits */ });
        }

        // --- events ------------------------------------------------------
        // Fill the body BEFORE the open animation (show, not shown) so the modal
        // animates in at its final size instead of resizing once content lands.
        modalEl.addEventListener('show.bs.modal', function () {
            input.value = '';
            lastQuery = null;
            renderEmpty();
        });
        // Focus only once it's fully shown (focusing mid-animation is janky).
        modalEl.addEventListener('shown.bs.modal', function () {
            input.focus();
        });

        input.addEventListener('input', function () {
            clearTimeout(timer);
            timer = setTimeout(run, DEBOUNCE_MS);
        });

        input.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowDown') { e.preventDefault(); moveActive(1); }
            else if (e.key === 'ArrowUp') { e.preventDefault(); moveActive(-1); }
            else if (e.key === 'Enter') {
                e.preventDefault();
                if (results.length && active >= 0) {
                    recordRecent(input.value);
                    window.location.assign(results[active].url);
                } else {
                    submit();
                }
            }
            // Esc is handled by Bootstrap (keyboard: true).
        });

        footCta.addEventListener('click', function () { recordRecent(input.value); });

        // Global shortcuts: Ctrl/Cmd-K toggles; "/" opens (unless typing).
        document.addEventListener('keydown', function (e) {
            var t = e.target || {};
            var typing = /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName) || t.isContentEditable;
            if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                modal.toggle();
            } else if (e.key === '/' && !typing && !modalEl.classList.contains('show')) {
                e.preventDefault();
                modal.show();
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
